import React from "react";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location.interfaces";

import iconIconPrint from "../../img/retail-locator/icon-print.svg";
import { LocatorSendResultsModal } from "./LocatorSendResults_Modal";

interface IProps {
    stores: IRetailStoreWithDistance[];
    getStoreNumber: (store: IRetailStoreWithDistance) => number;
}

export const LocatorSendResultsPrint = ({
    stores,
    getStoreNumber,
}: IProps): React.ReactNode => {
    const onSubmit = async () => {
        window.print();
    };

    // TODO(i18n): Use t tagged template: buttonLabel={t`Print`}
    // TODO(i18n): Use t tagged template: buttonImgAlt={t`Print`}
    // TODO(i18n): Use t tagged template: modalTitle={t`Print Your Results`}
    // TODO(i18n): Use t with interpolation to keep sentence together: modalDescription={t`Check up to ${5} results you would like to print.`}
    // TODO(i18n): Use t tagged template: submitButtonLabel={t`Print`}
    return (
        <LocatorSendResultsModal
            modalClassName="modal-print"
            bodyOpenClassName="locator-print-modal-open"
            buttonLabel="Print"
            buttonImgSrc={iconIconPrint}
            buttonImgAlt="Print"
            modalTitle="Print Your Results"
            modalDescription={
                <>
                    Check up to <strong>5</strong> <span>results</span> you
                    would like to print.
                </>
            }
            submitButtonLabel="Print"
            maxSelected={5}
            stores={stores}
            getStoreNumber={getStoreNumber}
            onSubmit={onSubmit}
        />
    );
};
